/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetMnthlyImp = (loanNumber, dueDate) => {
  const { get } = useAbortController();
  const { token } = useAuthContext();

  const [mnthlyImpInfo, setMnthlyImpInfo] = useState({
    mnthlyImpAmt: 0,
  });
  const [mnthlyImpStatus, setMnthlyImpStatus] = useState('done');

  const getMnthlyImpInfo = useCallback(async () => {
    if (!token || !loanNumber || !dueDate) return;
    const controller = get();
    const config = { signal: controller.signal };
    const headers = {
      'Session-Token': token,
    };

    try {
      setMnthlyImpStatus('loading');
      let response = await axiosCall(
        { url: `live/loan/${loanNumber}/impound/total/mnthly-imp-amt-at/${dueDate}`, method: 'get' },
        config,
        headers,
      );
      setMnthlyImpInfo({
        ...response,
        mnthlyImpAmt: response?.mnthlyImpAmt ?? 0,
      });
      setMnthlyImpStatus('done');
    } catch (e) {
      if (e.code !== 'ERR_CANCELED') {
        console.error('Unable to load monthly impound info: ' + e);
        setMnthlyImpStatus('error');
      }
    }
  }, [get, loanNumber, dueDate, token]);

  useEffect(() => {
    getMnthlyImpInfo();
  }, [getMnthlyImpInfo]);

  return {
    mnthlyImpInfo,
    mnthlyImpStatus,
  };
};

export default useGetMnthlyImp;
